import { ContractType, ParkingProductType } from "../ParkingProductModel";

export type DelegeesWithPagination = {
  totalRecords: number;
  pages: number;
  delegees: DelegeeWithProductsModel[];
};

export type DelegeeWithProductsModel = {
  registrationId: string;
  name: string;
  emailAddress: string;
  invitationAccepted: boolean;
  invitationDate: string;
  products: DelegatedParkingProductModel[];
};

export type DelegatedParkingRightsWithPagination = {
  totalRecords: number;
  pages: number;
  delegatedParkingRights: DelegatedParkingRight[];
}

export type InviteDelegeeResponse = {
  delegeeId: string;
  assignedProducts: DelegeeAssignedProductResponse[];
}

export type UpdateDelegeeResponse = {
  delegeeId: string;
  assignedProducts: DelegeeAssignedProductResponse[];
}

export type DelegeeAssignedProductResponse = {
  pmcId: number;
  entryRightId: string;
  contractId: string
  contractType: ContractType;
  productType: ParkingProductType;
  placeId: number;
}

export type AssignedParkingRightsWithPagination = {
  totalRecords: number;
  pages: number;
  assignedParkingRights: AssignedParkingRight[];
};

export type VehicleAssignmentsMyFleetWithPagination = {
  totalRecords: number;
  pages: number;
  vehicleAssignments: VehicleAssignment[];
};

export type VehicleAssignmentsMyFleetOverviewWithPagination = {
  totalUniqueVehicles: number;
  totalRecords: number;
  pages: number;
  vehicleAssignments: VehicleAssignmentMyFleet[];
};

export type VehicleAssignmentModel = {
  assignedProducts: AssignedProduct[];
  customerId: string;
  vehicle: {
    countryCode: string,
    description: string,
    value: string
  };
};

export type DelegatedParkingRight = {
  parkingRight : DelegatedParkingProductModel,
  delegee : DelegeeModel,
}

export type Vehicle = {
  countryCode: string;
  identifier: string;
  description?: string;
};

export type AssignedParkingRight = {
  vehicleAssignmentId: string;
  parkingRight: {
    id: string;
    pmc: number;
    name: string;
    location: string;
  };
  assigned: Date | string;
  vehicle: Vehicle;

  // the backend datetime offset 
  // but it's actually mapped from ParkingRight.StartDate in Season Tickets db
  // so you should ignore the timezone offset in that one
  startedAt: Date | string | null;
  activationDate: string | null;
  expirationDate: string | null;
  flexBudgetRemainingTime?: string;
  flexBudgetUnitType?: FlexBudgetUnitType;
  activeSessionSince?: string | null;
};

export type VehicleAssignmentProduct = {
  parkingRightId: string;
  pmcId: number;
  pmcName: string;
  locationName: string;
  activeSessionSince?: string | null;
}

export type VehicleAssignmentProductMyFleet = {
  parkingRightId: string;
  pmcId: number;
  pmcName: string;
  locationName: string;
  activationDate?: string | null;
  expirationDate?: string | null;
  activeSessionSince?: string | null;
}

export type VehicleAssignment = {
  vehicleAssignmentId: string;
  vehicle: Vehicle;
  products: VehicleAssignmentProduct[];
  assignedAt: Date;
}


export type VehicleAssignmentMyFleet = {
  vehicleAssignmentId: string;
  vehicle: Vehicle;
  product: VehicleAssignmentProductMyFleet | null;
  createdAt: Date;
}

export type DelegatedParkingProductModel = {
  parkingRightId: string,
  id: number;
  pmcId: number;
  name: string;
  location: string;
  created: Date;
  status: number;
  flexBudgetRemainingTime?: string | undefined;
  flexBudgetUnitType?: FlexBudgetUnitType | undefined;
  contractType: ContractType;
  productType: ParkingProductType;
};

export type DelegeeModel = {
  registrationId: string;
  name: string;
  emailAddress: string;
  invitationAccepted: boolean;
}

export type AssignedProduct = {
  assignedOn: Date;
  orderLineId: number;
  parkingRightId: string;
  pmcId: number;
  activationDate?: string | null;
  expiryDate?: string | null;
}

export enum FlexBudgetUnitType {
  Hours = 1,
  Quarters = 2,
  Minutes = 3
}